const middlewareAction = () => {
    // Code Event after catching the error middleware
}

export default middlewareAction
